export default "__VITE_ASSET__DV$1w98W__"